var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 15.7737C7.68045 16.3588 8.83008 16.6668 10.0003 16.6668C11.1706 16.6668 12.3202 16.3588 13.3337 15.7737C14.3471 15.1885 15.1887 14.347 15.7738 13.3335C16.359 12.32 16.667 11.1704 16.667 10.0002C16.667 8.82992 16.359 7.68029 15.7738 6.66683C15.1887 5.65337 14.3471 4.81178 13.3337 4.22666C12.3202 3.64154 11.1706 3.3335 10.0003 3.3335C8.83008 3.3335 7.68046 3.64154 6.66699 4.22666",
    stroke: "#EB3349",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 10.0002L0.886123 9.37547L0.386367 10.0002L0.886123 10.6249L1.66699 10.0002ZM9.16699 11.0002C9.71928 11.0002 10.167 10.5524 10.167 10.0002C10.167 9.44788 9.71928 9.00016 9.16699 9.00016V11.0002ZM4.21946 5.2088L0.886123 9.37547L2.44786 10.6249L5.78119 6.45819L4.21946 5.2088ZM0.886123 10.6249L4.21946 14.7915L5.78119 13.5421L2.44786 9.37547L0.886123 10.6249ZM1.66699 11.0002H9.16699V9.00016H1.66699V11.0002Z",
    fill: "#EB3349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.47b991c5fd5092156f6c0103a792e0d3.svg";
export { ForwardRef as ReactComponent };